/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { List } from 'immutable';
import { connect } from 'react-redux';
import I18n from 'I18n';
import UIWell from 'UIComponents/well/UIWell';
import UIWellItem from 'UIComponents/well/UIWellItem';
import UIWellBigNumber from 'UIComponents/well/UIWellBigNumber';
import UIWellLabel from 'UIComponents/well/UIWellLabel';
import UIWellHelpText from 'UIComponents/well/UIWellHelpText';
import UIWellConnector from 'UIComponents/well/UIWellConnector';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UILink from 'UIComponents/link/UILink';
import UIChevron from 'UIComponents/tag/UIChevron';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { dollars } from 'AdsUI/lib/Calculations';
import DealListDrop from 'AdsUI/components/DealListDrop';
import { FunnelStages, ContactListFunnelStage, EntityTypes, KBArticles, AttributionViews } from 'AdsUI/lib/Constants';
import HelpTooltip from 'AdsUI/components/HelpTooltip';
import { displayDecimalAsPercentage, getCurrencySymbol } from 'AdsUI/lib/Utils';
import { isDealsRoi, isAdWordsAccountConnected } from 'AdsUI/selectors/AccountsSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasAccessToRoiReporting } from 'AdsUI/selectors/AuthSelectors';
import ReportRecord from 'AdsUI/records/reporting/ReportRecord';
import UICardSection from 'UIComponents/card/UICardSection';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import ContactListDropContainer from 'AdsUI/components/ContactListDropContainer';
import NumberSkeleton from './NumberSkeleton';
import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink';
import WellsSpendROI from './WellsSpendROI';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { getAdSpendCurrencyChoice } from 'AdsUI/selectors/AdProfileSelectors';
import { getCustomerColumnLabel } from 'AdsUI/selectors/ColumnsSelectors';

const ContactsTooltip = ({
  attributionView
}) => {
  return /*#__PURE__*/_jsx(HelpTooltip, {
    title: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaigns.campaignTable.tooltips.CONVERSIONS.${attributionView}`
      }), ' ', /*#__PURE__*/_jsx(KnowledgeBaseLink, {
        kbArticle: KBArticles.AD_TRACKING,
        context: "wells-cortacts-tooltip"
      })]
    }),
    use: "default"
  });
};

const LoadingWell = ({
  customerColumnLabel,
  roiEnabled,
  showDeals,
  isAllFormSubmission
}) => /*#__PURE__*/_jsxs(UIWell, {
  wrapItems: false,
  children: [/*#__PURE__*/_jsxs(UIWellItem, {
    children: [/*#__PURE__*/_jsx(UIWellLabel, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "campaigns.impressions"
      })
    }), /*#__PURE__*/_jsx(UIWellBigNumber, {
      children: /*#__PURE__*/_jsx(NumberSkeleton, {
        size: "large"
      })
    })]
  }), /*#__PURE__*/_jsxs(UIWellItem, {
    children: [/*#__PURE__*/_jsx(UIWellLabel, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "campaigns.clicks"
      })
    }), /*#__PURE__*/_jsx(UIWellBigNumber, {
      children: /*#__PURE__*/_jsx(NumberSkeleton, {
        size: "large"
      })
    })]
  }), /*#__PURE__*/_jsxs(UIWellItem, {
    children: [/*#__PURE__*/_jsx(UIWellLabel, {
      children: isAllFormSubmission ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "campaigns.totalSubmissions"
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "campaigns.newContacts"
      })
    }), /*#__PURE__*/_jsx(UIWellBigNumber, {
      children: /*#__PURE__*/_jsx(NumberSkeleton, {
        size: "large"
      })
    })]
  }), roiEnabled && /*#__PURE__*/_jsxs(UIWellItem, {
    children: [/*#__PURE__*/_jsx(UIWellLabel, {
      children: showDeals ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "campaigns.deals"
      }) : customerColumnLabel || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "campaigns.customers"
      })
    }), /*#__PURE__*/_jsx(UIWellBigNumber, {
      children: /*#__PURE__*/_jsx(NumberSkeleton, {
        size: "large"
      })
    })]
  })]
});

const FunnelPercentageArrow = ({
  start,
  finish
}) => {
  if (!start || finish === null) {
    return null;
  }

  return /*#__PURE__*/_jsx(UIWellConnector, {
    children: /*#__PURE__*/_jsx(UIChevron, {
      children: displayDecimalAsPercentage(finish / start)
    })
  });
};

const MoneySpentPerMetric = ({
  value: {
    amount,
    currencyCode
  }
}) => {
  const currencySymbol = getCurrencySymbol(currencyCode);
  const displayValue = dollars(amount, currencySymbol);

  if (!amount || !displayValue) {
    return '';
  }

  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "campaigns.moneySpentPerMetric",
    options: {
      price: displayValue
    }
  });
};

class CampaignPerformanceWells extends PureComponent {
  shouldShowWhereAreConversions(funnelStage, total) {
    const {
      adWordsConnected
    } = this.props;
    return Boolean(funnelStage === FunnelStages.CONVERSIONS && total === 0 && !adWordsConnected);
  }

  formatOrAbbreviateNumber(number) {
    return /*#__PURE__*/_jsx(FormattedNumber, {
      value: number,
      abbreviate: true,
      maxFractionDigits: 0,
      abbreviateThreshold: 0
    });
  }

  renderContactList(funnelStage, total) {
    if (this.props.dashboard && this.shouldShowWhereAreConversions(funnelStage, total)) {
      return /*#__PURE__*/_jsx(UITooltip, {
        use: "longform",
        placement: "bottom",
        headingText: I18n.text('onboarding.whereArePreviousConversions.title'),
        title: I18n.text('onboarding.whereArePreviousConversions.description'),
        children: /*#__PURE__*/_jsx(UILink, {
          href: "",
          onClick: e => {
            e.preventDefault();
          },
          children: "0"
        })
      });
    } else {
      const {
        entity,
        network,
        globalFilters,
        attributionView,
        overrideAdAccounts
      } = this.props;
      return /*#__PURE__*/_jsx(ContactListDropContainer, {
        network: network,
        globalFilters: globalFilters,
        attributionView: attributionView,
        value: total,
        entity: entity,
        entityType: EntityTypes.CAMPAIGN,
        funnelStage: funnelStage,
        overrideAdAccounts: overrideAdAccounts
      });
    }
  }

  renderWells(showDeals) {
    const {
      data: {
        newContacts,
        costPerNewContact,
        costPerCustomer,
        costPerDeal,
        impressions,
        clicks,
        costPerClick,
        deals,
        dealsDetails,
        customers
      },
      globalFilters: {
        attributionView
      },
      roiEnabled,
      customerColumnLabel
    } = this.props;
    const isAllFormSubmission = attributionView === AttributionViews.ALL_FORM_SUBMISSIONS;
    return /*#__PURE__*/_jsxs(UIWell, {
      wrapItems: false,
      children: [/*#__PURE__*/_jsxs(UIWellItem, {
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "campaigns.impressions"
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: this.formatOrAbbreviateNumber(impressions)
        }), /*#__PURE__*/_jsx(FunnelPercentageArrow, {
          start: impressions,
          finish: clicks
        })]
      }), /*#__PURE__*/_jsxs(UIWellItem, {
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "campaigns.clicks"
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: this.formatOrAbbreviateNumber(clicks)
        }), /*#__PURE__*/_jsx(UIWellHelpText, {
          children: /*#__PURE__*/_jsx(MoneySpentPerMetric, {
            value: costPerClick
          })
        }), /*#__PURE__*/_jsx(FunnelPercentageArrow, {
          start: clicks,
          finish: newContacts
        })]
      }), /*#__PURE__*/_jsxs(UIWellItem, {
        "data-test-id": "well-new-contacts",
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsxs("span", {
            children: [isAllFormSubmission ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "campaigns.totalSubmissions",
              "data-test-id": "total-submissions-title"
            }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "campaigns.newContacts",
              "data-test-id": "contacts-title"
            }), /*#__PURE__*/_jsx(ContactsTooltip, {
              attributionView: attributionView
            })]
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: this.renderContactList(ContactListFunnelStage.CONVERSION, newContacts)
        }), /*#__PURE__*/_jsx(UIWellHelpText, {
          children: /*#__PURE__*/_jsx(MoneySpentPerMetric, {
            value: costPerNewContact
          })
        }), roiEnabled && /*#__PURE__*/_jsx(FunnelPercentageArrow, {
          start: newContacts,
          finish: showDeals ? deals : customers
        })]
      }), roiEnabled && (showDeals ? /*#__PURE__*/_jsxs(UIWellItem, {
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "campaigns.deals"
            }), /*#__PURE__*/_jsx(HelpTooltip, {
              title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "campaigns.dealsTooltip"
              }),
              use: "default"
            })]
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: deals ? /*#__PURE__*/_jsx(DealListDrop, {
            deals: dealsDetails,
            total: deals
          }) : 0
        }), /*#__PURE__*/_jsx(UIWellHelpText, {
          children: /*#__PURE__*/_jsx(MoneySpentPerMetric, {
            value: costPerDeal
          })
        })]
      }) : /*#__PURE__*/_jsxs(UIWellItem, {
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsxs("span", {
            children: [customerColumnLabel || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "campaigns.customers"
            }), /*#__PURE__*/_jsx(HelpTooltip, {
              title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "campaigns.customersTooltip",
                options: {
                  customers: customerColumnLabel
                }
              }),
              use: "default"
            })]
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: this.renderContactList(ContactListFunnelStage.CUSTOMER, customers)
        }), /*#__PURE__*/_jsx(UIWellHelpText, {
          children: /*#__PURE__*/_jsx(MoneySpentPerMetric, {
            value: costPerCustomer
          })
        })]
      }))]
    });
  }

  render() {
    const {
      isLoaded,
      dealsRoi,
      roiEnabled,
      data,
      adSpendCurrencyChoice,
      customerColumnLabel,
      globalFilters
    } = this.props;
    const style = !isLoaded ? {
      minHeight: '194px'
    } : {};
    return /*#__PURE__*/_jsxs(UIGrid, {
      className: "m-bottom-4",
      style: style,
      "data-test-id": "campaigns-performance-wells",
      children: [/*#__PURE__*/_jsx(UIGridItem, {
        size: 8,
        className: "p-right-0",
        children: /*#__PURE__*/_jsx(UICardWrapper, {
          className: this.props.className,
          style: {
            height: '95%'
          },
          compact: true,
          children: /*#__PURE__*/_jsx(UICardSection, {
            className: "p-y-0",
            children: isLoaded ? this.renderWells(dealsRoi) : /*#__PURE__*/_jsx(LoadingWell, {
              roiEnabled: roiEnabled,
              showDeals: dealsRoi,
              customerColumnLabel: customerColumnLabel,
              isAllFormSubmission: globalFilters.attributionView === AttributionViews.ALL_FORM_SUBMISSIONS
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIGridItem, {
        size: 4,
        children: /*#__PURE__*/_jsx(UICardWrapper, {
          className: this.props.className,
          style: {
            height: '95%'
          },
          compact: true,
          children: /*#__PURE__*/_jsx(WellsSpendROI, {
            data: data,
            loading: !isLoaded,
            adSpendCurrencyChoice: adSpendCurrencyChoice
          })
        })
      })]
    });
  }

}

CampaignPerformanceWells.propTypes = {
  data: PropTypes.instanceOf(ReportRecord),
  isLoaded: PropTypes.bool.isRequired,
  activeWell: PropTypes.string,
  supplementalKey: PropTypes.string,
  supplementalOption: PropTypes.object,
  dashboard: PropTypes.bool,
  adWordsConnected: PropTypes.bool,
  dealsRoi: PropTypes.bool,
  roiEnabled: PropTypes.bool.isRequired,
  overrideAdAccounts: PropTypes.instanceOf(List)
};

const select = state => {
  return {
    adWordsConnected: isAdWordsAccountConnected(state),
    dealsRoi: isDealsRoi(state),
    roiEnabled: hasAccessToRoiReporting(state),
    globalFilters: getGlobalFilters(state),
    adSpendCurrencyChoice: getAdSpendCurrencyChoice(state),
    customerColumnLabel: getCustomerColumnLabel(state)
  };
};

export default connect(select, {})(CampaignPerformanceWells);